/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';

const POSITIONS = {
  [cardProviders.MONAVATE]: {
    x: 188,
    y: 168,
    fontSize: 16,
  },
};
export function PinValue({ isVisible, onClick = () => {} }) {
  const { cardProvider } = useUserCardProvider();
  if (!isVisible) return null;

  const { x = 183, y = 130, fontSize = 16 } = POSITIONS[cardProvider] || {};

  return (
    <g>
      <text
        className="cursor-pointer"
        fill="white"
        fontWeight="bold"
        fontSize={fontSize}
        x={x}
        y={y}
        onClick={onClick}>
        ****
      </text>
    </g>
  );
}
PinValue.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
export default PinValue;
